module.exports = __webpack_public_path__ + "img/pc_bigwin_bg.a83240b.webp";